module.exports = __webpack_public_path__ + "media/2.dfe14403.wav";